import React from 'react'
import { useAppSelector } from '../../app/hooks'
import { selectIsAuth } from './AuthSlice'
import {
  Navigate,
  useLocation,
  Outlet,
} from 'react-router-dom'

import { Box } from '@mui/material'
import { IS_LITE } from '../../app/const'
const useQuery = () => new URLSearchParams(useLocation().search)

export interface ProtectedRouteProps {
  redirectTo: string
}
const ProtectedRoute = ({ redirectTo, ...props }: ProtectedRouteProps) => {
  const query = useQuery()
  const domain = query?.get('domain')
  let location = useLocation()
  console.log('ProtectedRoute', location, redirectTo, domain)
  const isAuth = useAppSelector(selectIsAuth) || IS_LITE || domain === 'pure' || location?.pathname?.startsWith('/analysis/slug/')
  return isAuth ? (<Box mt={1}> <Outlet /> </Box>)
    : (<Navigate to={redirectTo} state={{ from: location }} />)
}

export default ProtectedRoute